<template>
  <div class="pagination-widget">
    <button class="btn btn-minus" @click="prev()">
      <img src="@/assets/images/icons/curret_left_black.svg" />
    </button>
    <template v-for="(item, index) in page_data">
      <button
        class="page"
        :key="index"
        :class="{ active: item.page == current_page }"
        @click="onClick(item)"
        v-if="item.page > 0"
      >
        {{ item.page }}
      </button>
    </template>

    <button class="btn btn-plus" @click="next()">
      <img src="@/assets/images/icons/curret_right_black.svg" />
    </button>
  </div>
</template>

<script>
export default {
  name: "pagination-widget",
  props: {
    all: {
      type: Number,
      default: 0,
    },
    perpage: {
      type: Number,
      default: 10,
    },
    current: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      page_data: [],
      all_page: 0,
      current_page: 0,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.startPaginate();
  },
  methods: {
    startPaginate() {
      let vm = this;
      vm.current_page = vm.current;
      vm.page_data = [];
      vm.all_page = Math.ceil(vm.all / vm.perpage);
      if (vm.current_page > 3) {
        let start =
          vm.all_page - 3 < vm.current_page
            ? vm.all_page - 5
            : vm.current_page - 2;
        let end =
          vm.all_page > vm.current_page + 3 ? vm.current_page + 3 : vm.all_page;
        for (let page = start; page <= end; page++) {
          vm.page_data.push({
            page: page,
          });
        }
      } else {
        let start = 1;
        let end = vm.all_page > 6 ? 6 : vm.all_page;
        for (let page = start; page <= end; page++) {
          vm.page_data.push({
            page: page,
          });
        }
      }
    },
    onClick(item) {
      let vm = this;
      vm.current_page = item.page;
      vm.$emit("change", item.page);
    },
    prev() {
      let vm = this;
      if (vm.current_page > 1) {
        vm.current_page -= 1;
        vm.page_data = [];
        vm.all_page = Math.ceil(vm.all / vm.perpage);
        if (vm.current_page > 3) {
          let start =
            vm.all_page - 3 < vm.current_page
              ? vm.all_page - 5
              : vm.current_page - 2;
          let end =
            vm.all_page > vm.current_page + 3
              ? vm.current_page + 3
              : vm.all_page;
          for (let page = start; page <= end; page++) {
            vm.page_data.push({
              page: page,
            });
          }
        } else {
          let start = 1;
          let end = vm.all_page > 6 ? 6 : vm.all_page;
          for (let page = start; page <= end; page++) {
            vm.page_data.push({
              page: page,
            });
          }
        }
        vm.$emit("change", vm.current_page);
      }
    },
    next() {
      let vm = this;
      if (vm.current_page < vm.all_page) {
        vm.current_page += 1;
        vm.page_data = [];
        vm.all_page = Math.ceil(vm.all / vm.perpage);
        if (vm.current_page > 3) {
          let start =
            vm.all_page - 3 < vm.current_page
              ? vm.all_page - 5
              : vm.current_page - 2;
          let end =
            vm.all_page > vm.current_page + 3
              ? vm.current_page + 3
              : vm.all_page;
          for (let page = start; page <= end; page++) {
            vm.page_data.push({
              page: page,
            });
          }
        } else {
          let start = 1;
          let end = vm.all_page > 6 ? 6 : vm.all_page;
          for (let page = start; page <= end; page++) {
            vm.page_data.push({
              page: page,
            });
          }
        }
        vm.$emit("change", vm.current_page);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.pagination-widget {
  display: flex;
  align-items: center;
  .btn {
    height: 35px;
    width: 35px;
    background: #f8f9fa;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    margin: 0px 8px;
    &:hover {
      opacity: 0.8;
    }
    img {
      width: 6px;
    }
  }
  .page {
    height: 35px;
    width: 35px;
    background: #f8f9fa;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    margin: 0px 8px;
    &:hover {
      opacity: 0.8;
    }
    &.active {
      border: 1px solid $color_primary;
      color: $color_primary;
    }
  }
}
</style>
